<template>

  <div >
    <div class="form__group">
    <label :for="name" v-if="label">{{ label }}: <span class="required" v-if="required">*</span></label>
    <input type="file" id="uploadCaptureInputFile" :name="name" @change="onFileSelect" :required="required" class="form-control" :class="{'is-danger': fileError || hasError }">
    <span class="help is-danger" v-if="fileError || hasError">{{ errorMessage }}</span>
  </div>
    <sweet-modal ref="cropImage" hide-close-button blocking>
      <div >
        <VueCropper v-show="selectedFile" ref="cropper" :viewMode="3" :zoomable="false"  :aspect-ratio="4/3" :src="selectedFile" alt="Source Image"></VueCropper>               
        <div>
          <button class="btn btn--primary"  @click="cancel()">Cancel</button>
          <button class="btn btn--primary" style="margin-right:10px" id="save-race-image" @click="cropImage()">Save</button>          
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import axios from 'axios'
import VueCropper from 'vue-cropperjs'
const Compress = require('client-compress')
import 'cropperjs/dist/cropper.css'
import service from '@/services/index'
import { mapActions } from 'vuex'
import { SweetModal } from "sweet-modal-vue"

const resource = service.resource('races/upload-image')

export default {
  components: { VueCropper,SweetModal },
  // props: ['image_name'],
   props: {
    label: {
      required: false,
      type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      type: String
    },
    errorMessage: {
      required: false,
      type: String
    },
    hasError: {
      required: false
    },
    required: {
      type: Boolean
    }
  },
  data() {
    return {
      input: '',
      mime_type: '',
      cropedImage: '',
      autoCrop: false,
      selectedFile: '',
      image: '',
      dialog: false,
      files: '',
      file_name:'',
      fileError:false
    }
  },
  computed: {

  },
  methods: {
    cropImage() {
      console.log("crop image inside")
      // const userId = this.$route.params.user_id
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL()    
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const size = blob.size/1024
          console.log("size---",size)
          if(size > 200){
            this.compressImage(blob) //Compress image if file size is larger than 200kb
            //  this.fileError=true
            //  this.$emit('input', null)
            //  this.$refs.cropImage.close()  
          }else { 
            this.fileError=false
            const formData = new FormData()
            formData.append('file', blob, this.file_name)  
            this.saveImageButton()     
            this.addTaskToQueue('saveRacePhoto')
              resource.save(formData)
                .then(({ body }) => {
                this.$emit('input', body.url)
                this.removeTaskFromQueue('saveRacePhoto')
                this.resetSaveImageButton()
                this.$refs.cropImage.close()      
              })
          }
      }, this.mime_type)
    },
    onFileSelect(e) {
      const file = e.target.files[0]      
      const size = file.size/1024
      console.log("size---",size)
      if(size <= 200){
        const imgFile = new FormData()
        imgFile.append('file', file)
         this.addTaskToQueue('saveRacePhoto')
          resource.save(imgFile)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveRacePhoto')
          })
      }else{
        this.mime_type = file.type
        if (typeof FileReader === 'function') {
          this.dialog = true
          const reader = new FileReader()
          reader.onload = (event) => {
            this.selectedFile = event.target.result
            this.$refs.cropper.replace(this.selectedFile)
          }
          reader.readAsDataURL(file)
          this.$refs.cropImage.open()
        } else {
          alert('Sorry, FileReader API not supported')
        }
      }
    },
    compressImage(blob){
      console.log("Compress Image")
      const options = {
        targetSize: 0.2,
        quality: 0.75,
        maxWidth: 800,
        maxHeight: 600
      }
      const compress = new Compress(options)
      compress.compress([blob]).then((conversions) => {        
        const { photo, info } = conversions[0]           
        const size = photo.data.size/1024
        console.log("Compress image size---",size)
        if(size > 200){
          this.fileError=true
          this.$emit('input', null)
          this.$refs.cropImage.close()  
        }else {             
          this.fileError=false
          const formData = new FormData()
          formData.append('file', photo.data)
          this.saveImageButton()     
          this.addTaskToQueue('saveRacePhoto')
          resource.save(formData)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveRacePhoto')
            this.resetSaveImageButton()
            this.$refs.cropImage.close()      
          })
        } 
      })
    },
    saveImageButton() {
        const btnsave = document.querySelector('#save-race-image')
        btnsave.innerHTML = 'Saving...'
        btnsave.setAttribute('disabled', true)
      },
    resetSaveImageButton() {
        const btnsave = document.querySelector('#save-race-image')
        btnsave.innerHTML = 'Save'
        btnsave.removeAttribute('disabled', true)
    },
    onClose() {
      this.$refs.cropImage.close()      
    },
    cancel(){
      document.getElementById("uploadCaptureInputFile").value = ""
      this.$refs.cropImage.close()   
    },
     ...mapActions({
      addTaskToQueue: 'LoadingQueue/addTaskToQueue',
      removeTaskFromQueue: 'LoadingQueue/removeTaskFromQueue'
    })
  },
}
</script>
<style scoped>
.user {
  width: 140px;
  height: 140px;
  border-radius: 100%;
  border: 3px solid #2e7d32;
  position: relative;
}
.profile-img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
.icon {
  position: absolute;
  top: 10px;
  right: 0;
  background: #e2e2e2;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
  text-align: center;
  color: #0000ff;
  font-size: 14px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// UploadPhoto.vue?e8ccbb98